import { useCssTransition } from "hooks/useCssTransition";
import { TransitionState } from "hooks/useCssTransition/types";

import styles from "./styles.module.css";

export type MainNavigationTransition = {
  transitionClasses?: string;
  onTransitionEnd?: boolean;
};

const useMainNavigationFadeTransition = (visible: boolean): MainNavigationTransition => {
  const { getClassNames, state } = useCssTransition({
    visible,
    timeout: 300,
  });

  const transitionClasses = getClassNames({
    enter: styles.enter,
    enterActive: styles.enterActive,
    exit: styles.exit,
    exitActive: styles.exitActive,
  });

  return { transitionClasses, onTransitionEnd: state === TransitionState.EXITED };
};

export default useMainNavigationFadeTransition;
